/* eslint-disable 
jsx-a11y/label-has-associated-control, jsx-a11y/anchor-is-valid ,no-unused-expressions  */

import React, { useEffect, useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
import { Link } from 'react-router-dom';
import styles from './View.Style';
import NxtCircularLoader from 'components/nxt_circular_loader/View';
import SmeMapperAssignTools from './SmeMapperAssignTools';

const useStylesChallenge = makeStyles((theme) => ({
  root: { 
    width: '100%',
    display:'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh'
},
  title: {
    fontFamily: 'VodafoneRg-bold',
    fontSize: '2.125rem',
    margin: '1rem 0 2rem 0',
    textAlign: 'left',
    paddingTop: '1rem',
    color: theme.palette.primary.main,
  },
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    flexWrap: 'wrap',
  },
  fieldsetBox: {
    marginBottom: theme.spacing(1),
    border: 0,
    padding: 0,
    background: 'transparent',
    '& label': {
      fontFamily: 'VodafoneRg-bold',
      fontSize: '1rem',
      margin: '1rem 0 0.5rem 0',
      textAlign: 'left',
      color: '#333',
      display: 'block',
    },
    '& input[type="text"], input[type="date"], select': {
      fontFamily: 'VodafoneRg-Regular',
      fontSize: '1rem',
      margin: '0 0 0.5rem 0',
      textAlign: 'left',
      color: '#333',
      background: '#fff',
      borderRadius: '4px',
      width: '100%',
      minHeight: '3rem',
      border: '1px solid #333',
      padding: '0.5rem',
      boxSizing: 'border-box',
    },
  },
  invalidInput: { '& [aria-invalid="true"]': { borderColor: 'red' } },
  error: {
    color: 'red',
    fontFamily: 'VodafoneRg-Regular',
    fontSize: '1rem',
    margin: '0.25rem 0 0.5rem 0',
  },
  labelname: {
    fontFamily: 'VodafoneRg-bold',
    fontSize: '1rem',
    margin: '0 0 0.5rem 0',
    textAlign: 'left',
    color: '#333',
    display: 'block',
  },
  rowHeader: {
    display: 'grid',
    gridTemplateColumns: '40% 1fr',
    alignItems: 'center',
    background: '#f5f5f5',
    padding: '8px 10px',
    borderBottom: '1px solid #e0e0e0',
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '40% 1fr',
    alignItems: 'center',
    padding: '8px 10px',
    borderBottom: '1px solid #f0f0f0',
  },
  ideasWrapper: {
    marginTop: '0.5rem',
    border: '1px solid #eee',
    borderRadius: 6,
    overflow: 'hidden',
  },
  getIdeasBtn: {
    fontFamily: 'VodafoneRg-bold',
    padding: '0.6rem 1rem',
    borderRadius: '2rem',
    border: '1px solid',
    borderColor: theme.palette.primary.light,
    background: theme.palette.primary.main,
    color: '#fff',
    cursor: 'pointer',
    '&:disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
      background: theme.palette.primary.light,
    },
  },
}));




const matchByIds = (ids, data) => {
  const set = new Set(ids);
  return data.filter(item => set.has(item.id));
};


const SmeMapper = (props) => {
    console.log("props, SmeMapper", props)
  const classes = useStylesChallenge();
  const {
    getInnovateChallengeAllListFn,
    getInnovateChallengeFilterListFn,
    listCommunitesChallenge,
    getCommunitesAsGroup,
    listInnovateChallenge,
    getInnovateChallengeTaggedIdeaListFn,
    deleteAllAssignedEvaluatorIntoIdeaFn,
    InnovateGetChallengeTaggedIdeaListIsLoading,
    postInnovateIdeaAddBySMEGroupsIsLoading,
    InnovateGetChallengeTaggedIdeaList,
    deleteAssignedEvaluatorIntoIdeaFn,
    postInnovateIdeaAddBySMEGroupsFn
  } = props || {};

  const [selectedChallengeId, setSelectedChallengeId] = useState('');
  const [selectedCommunityId, setSelectedCommunityId] = useState('');
  const [ideas, setIdeas] = useState([]);
  const [error, setError] = useState('');
  const isActiveSelectedChallengeId = !!selectedChallengeId;
  // Single evaluator per idea: ideaId -> evaluatorName
  const [assignedEvaluators, setAssignedEvaluators] = useState({});

  useEffect(() => {
    // getInnovateChallengeAllListFn && getInnovateChallengeAllListFn();
    getInnovateChallengeFilterListFn('ACTIVE', 0, 400, true);
    getCommunitesAsGroup && getCommunitesAsGroup();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    if(selectedChallengeId){
      getInnovateChallengeTaggedIdeaListFn(selectedChallengeId)
    }
  },[selectedChallengeId])

  const handleChallengeChange = (e) => {
    setSelectedChallengeId(e.target.value);
    setError('');
    setIdeas([]);
    setAssignedEvaluators({});
  };

  // const getGroupListAttachedWithChallenge = getCommunitesAsGroup.filter((grp)=>{
  //      return grp.id === getSingleChallengeObj?.groupListK
  //  })  



  return (
    <Container className={`${classes.root} ${classes.invalidInput}`}>
      {/* Results */}
      <div style={{width:'100%'}} >
        <NxtCircularLoader isLoading={postInnovateIdeaAddBySMEGroupsIsLoading}>
        <SmeMapperAssignTools 
          challengeList={listInnovateChallenge || []}
          smeGroupList={listCommunitesChallenge || []}
          taggedIdeaList={InnovateGetChallengeTaggedIdeaList}
          isLoadingIdeaList={InnovateGetChallengeTaggedIdeaListIsLoading}
          getInnovateChallengeTaggedIdeaListFn={getInnovateChallengeTaggedIdeaListFn}
          deleteAllAssignedEvaluatorIntoIdeaFn={deleteAllAssignedEvaluatorIntoIdeaFn}
          deleteAssignedEvaluatorIntoIdeaFn={deleteAssignedEvaluatorIntoIdeaFn}
          postInnovateIdeaAddBySMEGroupsFn={postInnovateIdeaAddBySMEGroupsFn}
        />
        </NxtCircularLoader>
      </div>
    </Container>
  );
};

export default withStyles(styles)(SmeMapper);